import { render } from "./BottomSection.vue?vue&type=template&id=452132d8&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"

import "./BottomSection.vue?vue&type=style&index=0&id=452132d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452132d8"]])

export default __exports__